import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-05-30
 * @brief SEI 오늘의 점검 팝업
 *
 ********************************************************************/
//recoil
import { useRecoilState } from "recoil";
import { alertState } from "../../../recoil/assessmentState";
// utils
import { Trans } from "react-i18next";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
function ConfirmPop(props) {
    const t = useTrans();
    const [alert, setAlert] = useRecoilState(alertState);
    //  body
    const popBody = props.popBody;
    // 닫기 버튼
    const htmlClose = !CUTIL.isnull(popBody)
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("htmlClose")
                ? popBody.props.htmlClose
                : null
            : null
        : null;
    // 처음 팝업 아이디
    const layerId = !CUTIL.isnull(popBody)
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("id")
                ? popBody.props.id
                : null
            : null
        : null;
    //종류에 따라 화면 다르게 나옴
    const types = !CUTIL.isnull(popBody)
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("type")
                ? popBody.props.type
                : null
            : null
        : null;
    // fn 이벤트
    const clickfn = !CUTIL.isnull(popBody)
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("clickfn")
                ? popBody.props.clickfn
                : null
            : null
        : null;
    // 진단점검 프로그래스바
    const profn = !CUTIL.isnull(popBody)
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("profn")
                ? popBody.props.profn
                : null
            : null
        : null;
    function Close(id) {
        if (types == "today") {
            CUTIL.jsclose_InnerPopup(id, layerId);
        }
        else {
            CUTIL.jsclose_Popup(id);
        }
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-confirm", className: "popup-layer js-layer hidden popup-basic inner-popup" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "Confirm" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close(CONST.POP_CONFIRM) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), types == "today" ? (_jsx(ToDay, { layerId: layerId, clickfn: clickfn, t: t })) : types == "check" ? (_jsx(Check, { clickfn: clickfn, profn: profn, t: t })) : types == "banner" ? (_jsx(Banner, { t: t })) : ("")] })) }));
}
export default ConfirmPop;
function ToDay(props) {
    // props
    const { layerId, clickfn, t } = props;
    function ActionBtn(id) {
        clickfn();
        CUTIL.jsclose_InnerPopup(CONST.POP_CONFIRM, id);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.설비및진단정보를등록하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_InnerPopup(CONST.POP_CONFIRM, layerId) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => ActionBtn(layerId) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function Check(props) {
    // props
    const { profn, clickfn, t } = props;
    function ActionBtn(id) {
        clickfn();
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx(Trans, Object.assign({ i18nKey: "오늘의점검.점검진행", values: { profn: profn } }, { children: _jsxs("p", { children: ["LS \uC810\uAC80 \uC9C4\uD589\uC774 ", profn, "% \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC810\uAC80\uC744 \uC644\uB8CC\uD558\uACE0 \uACB0\uACFC\uB97C \uD655\uC778\uD560\uAE4C\uC694? \uBBF8\uC774\uD589 \uD56D\uBAA9\uC740 \uC804\uBD80", " ", _jsx("strong", { children: "\uD310\uC815\uBD88\uAC00 \uCC98\uB9AC" }), "\uB429\uB2C8\uB2E4."] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup(CONST.POP_CONFIRM) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => ActionBtn(CONST.POP_CONFIRM) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function Banner(props) {
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { profn, clickfn, t } = props;
    function ActionBtn(id) {
        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "서비스 준비 중입니다." }));
        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        CUTIL.jsclose_InPopup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uD574\uB2F9 \uC11C\uBE44\uC2A4\uAC00 \uC124\uCE58 \uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4." }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup(CONST.POP_CONFIRM) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => ActionBtn(CONST.POP_CONFIRM) }, { children: _jsx("span", { children: "\uC124\uCE58 \uD558\uAE30" }) }))] }))] }));
}
